import { createAction } from '@reduxjs/toolkit';

import types from './types';

type GPSLocation = {
  latitude?: number;
  longitude?: number;
  zoom?: number;
}

const changeGPSLocation = createAction<GPSLocation>(types.CHANGE_GPS_LOCATION);
const resetGPSLocation = createAction(types.RESET_GPS_LOCATION);

export default {
  changeGPSLocation,
  resetGPSLocation,
};
